<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter"
      :style="headerStyle"
    ></parallax>
    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto profile-header-container">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid"
                  />
                </div>
                <div class="name">
                  <!-- <h3 class="title">Catriona O'Connell</h3> -->
                  <simple-svg
                    class="title"
                    :filepath="logo"
                    :id="'custom-id'"
                  />
                  <h6 class="sub-title">Hair Stylist</h6>
                  <md-button
                    target="_blank"
                    href="https://www.facebook.com/CatrionaHairStylist/"
                    class="md-just-icon md-simple md-dribbble"
                    ><i class="fab fa-facebook"></i
                  ></md-button>
                  <md-button
                    target="_blank"
                    href="https://www.instagram.com/catrionahair/"
                    class="md-just-icon md-simple md-twitter"
                    ><i class="fab fa-instagram"></i
                  ></md-button>
                </div>
              </div>
            </div>
          </div>
          <h3 class="text-center">Make an Appointment</h3>
          <md-button class="md-primary description" href="tel:0214893733">
            <md-icon>phone</md-icon> Call Paris Hair and Beauty: (021) 489 3733
          </md-button>
          <md-button class="md-primary description" href="https://phorest.com/book/salons/parishairbeauty#/staffs/HaRX6aOE7GkKJTwKSRVzzw">
            <md-icon>calendar_today</md-icon> Book Online Now
          </md-button>
          <div class="description text-center">
            <p>
              With over 20 years’ experience, Catriona is an expert at her craft. She works individually with her clients to create beautiful styles.
            </p>
            <p>
              A session with Catriona is a one-to-one experience, where clients receive the full attention of the stylist from start to finish. Catriona’s focus is on hair-health and she works with each client to achieve healthy gloss, as well as a style and shape that best suits their look.
            </p>
            <p>
              Catriona specialises in creative cutting, balayage, highlighting and advanced colour.
            </p>
            <p>
              Catriona has worked in one of Ireland’s largest hair salons, as well as renowned salon, Sobe Brown. She has been a guest stylist at RSVP Magazine and Xpose Live. She is currently working out of Paris Hair and Beauty Douglas Court Shopping Centre, Cork. 
            </p>
            <!-- <h4 class="ca-cta btn">
              Make an Appointment: 
              <a href="tel:+353872730162">
                087 273 0162
              </a>
            </h4> -->
          </div>
          <div class="ch-section">
            <h3 class="text-center">What People Say</h3>
            <div class="ca-reviews-container">
              <md-card
                class="ca-review"
                v-for="(review, index) in reviews"
                :key="index"
              >
                <md-card-content>
                  <div 
                    class="ca-review-container"
                  >
                    <div class="ca-review--by">
                      <div class="ca-review--by-image">
                        <img
                          :src="review.userimg"
                          alt="Circle Image"
                          class="img-raised rounded-circle img-fluid"
                        />
                      </div>
                    </div>
                    <p>
                      {{review.text}}
                    </p>
                  </div>
                  <div class="ca-review--signature">
                    <p>
                      <span class="ca-review--by-name">
                        {{review.name}}
                      </span> -
                      <small>
                        {{review.userdetails}}
                      </small>
                    </p>
                  </div>
                </md-card-content>
              </md-card>
            </div>
            <md-button class="md-primary description" href="tel:0214893733">
              <md-icon>phone</md-icon> Call Paris Hair and Beauty: (021) 489 3733
            </md-button>
            <md-button class="md-primary description" href="https://phorest.com/book/salons/parishairbeauty#/staffs/HaRX6aOE7GkKJTwKSRVzzw">
              <md-icon>calendar_today</md-icon> Book Online Now
            </md-button>
          </div>
          <div class="ch-section directions">
            <h3 class="text-center">Where to Find Me</h3>
            <p>Paris Hair and Beauty Douglas Court Shopping Centre</p>
            <div class="name">
              <md-button
                target="_blank"
                href="https://www.facebook.com/CatrionaHairStylist/"
                class="md-just-icon md-simple md-dribbble"
                ><i class="fab fa-facebook"></i
              ></md-button>
              <md-button
                target="_blank"
                href="https://www.instagram.com/catrionahair/"
                class="md-just-icon md-simple md-twitter"
                ><i class="fab fa-instagram"></i
              ></md-button>
            </div>
            <div class="opening-times">
              <div><span>Monday:</span> <span>not available</span></div>
              <div><span>Tuesday:</span> <span>09:00 - 18:00 appointment only</span></div>
              <div><span>Thursday:</span> <span>09:00 - 18:00 appointment only</span></div>
              <div><span>Friday:</span> <span>09:00 - 18:00 appointment only</span></div>
              <div><span>Saturday:</span> <span>09:00 - 18:00 appointment only</span></div>
              <div><span>Sunday:</span> <span>not available</span></div>
            </div>
            <!-- <div class="description text-center">
              <p>
                <a target="_blank" href="https://www.google.com/maps/place/Sensus+Hair+Salon/@51.8772725,-8.4361524,347m/data=!3m1!1e3!4m5!3m4!1s0x484485e75cd93aa7:0x27e02038db3e8fe!8m2!3d51.8771186!4d-8.4359935?hl=en-GB">
                  Sensus Hair Salon 
                </a>
                No 3 Eastville East Douglas Street Douglas Village, Co. Cork, T12 KN83  
              </p>
            </div>
            <div class="mapouter">
              <div class="gmap_canvas"><iframe width="" height="500" id="gmap_canvas"
                src="https://maps.google.com/maps?q=Sensus%20Hair%20Salon%20cork&t=k&z=17&ie=UTF8&iwloc=&output=embed"
                frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
              </div>
            </div> -->
          </div>
          <!-- <div class="profile-tabs">
            <tabs
              :tab-name="['Studio', 'Work', 'Favorite']"
              :tab-icon="['camera', 'palette', 'favorite']"
              plain
              nav-pills-icons
              color-button="success"
            >
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <div class="md-layout-item md-size-25 ml-auto">
                    <img :src="tabPane1[0].image" class="rounded" />
                    <img :src="tabPane1[1].image" class="rounded" />
                  </div>
                  <div class="md-layout-item md-size-25 mr-auto">
                    <img :src="tabPane1[3].image" class="rounded" />
                    <img :src="tabPane1[2].image" class="rounded" />
                  </div>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <div class="md-layout-item md-size-25 ml-auto">
                    <img :src="tabPane2[0].image" class="rounded" />
                    <img :src="tabPane2[1].image" class="rounded" />
                    <img :src="tabPane2[2].image" class="rounded" />
                  </div>
                  <div class="md-layout-item md-size-25 mr-auto">
                    <img :src="tabPane2[3].image" class="rounded" />
                    <img :src="tabPane2[4].image" class="rounded" />
                  </div>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <div class="md-layout-item md-size-25 ml-auto">
                    <img :src="tabPane3[0].image" class="rounded" />
                    <img :src="tabPane3[1].image" class="rounded" />
                  </div>
                  <div class="md-layout-item md-size-25 mr-auto">
                    <img :src="tabPane3[2].image" class="rounded" />
                    <img :src="tabPane3[3].image" class="rounded" />
                    <img :src="tabPane3[4].image" class="rounded" />
                  </div>
                </div>
              </template>
            </tabs>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tabs } from "@/components";
import { LoginCard } from "@/components";

export default {
  components: {
    Tabs,
    LoginCard
  },
  bodyClass: "profile-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/examples/studio-1.jpg") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/cynthia-del-rio.jpg") },
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/clem-onojegaw.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/studio-3.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/studio-1.jpg") }
      ],
      logo: require("@/assets/img/catrionahair/logo.svg"),
      reviews: [
        { 
          userimg: require("@/assets/img/catrionahair/aisling.jpg"),
          name: 'Aisling Kelleher',
          userdetails: `Bridal & Upstyle Specialist`,
          text: `Catriona is the only person I will let cut my hair & the only stylist I 
            recommend to all my own bridal clients for their cuts & colours. 
            Whatever you ask for with your hair, Catriona will always listen and 
            give the best advice.`
        },
        { 
          userimg: require("@/assets/img/catrionahair/louise-cannon.png"),
          name: 'Louise Cannon',
          userdetails: `Marketing Strategist`,
          text: `
            There is no challenge too great for Catriona! For 10 years I have been 
            bringing pictures of elaborate hairstyles to the salon and watching in 
            awe as Catriona has recreated them on me. She has guided me expertly through 
            my desire to be every colour under the sun, always making sure that my 
            hair health has never suffered. Catriona has the kind of skill that you 
            expect to find in Paris or New York. Despite now living in Berlin, I still 
            return to Catriona regularly for my cut & colour. She’s a super warm person 
            and I look forward to every appointment! When you find a hair stylist 
            like this – you don’t let them go! 
          `
        },
        { 
          userimg: require("@/assets/img/catrionahair/ciara-tobin.jpg"),
          name: 'Ciara Tobin',
          userdetails: `Long time client`,
          text: `
            Catriona is an amazing hairdresser and I have no hesitation in recommending her.
            She has been looking after all of my hair needs for years now. Seeing me through
            changes of styles and colour. She always listens to the type of cut or highlights 
            I would like and makes it happen. She really cares about the condition of my hair 
            as well and is always careful to maintain it. Her bouncy blow dry is like no other 
            blow dry. Along with all of this Catriona is a really lovely person immediately 
            putting you at ease and great for the chats and giggles while you are in with her. 
            A real ten out of ten!
          `
        },
      ],
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/catrionahair/women.jpg")
    },
    img: {
      type: String,
      default: require("@/assets/img/catrionahair/ca-1.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    isEven(n) {
      return n % 2 == 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  margin-bottom: 0;
}

.sub-title {
  margin-top: 0;
}

.description {
  max-width: 630px !important;
  color: #3C4858;
  p {
    font-size: 1rem;
  }
}

.md-layout-item.md-size-50.profile-header-container {
  min-width: 280px;
  max-width: 50%;
  flex: 0 1 50%;

  .name {
    margin: 0 auto;
    margin-top: -80px;
    max-width: 350px;
  }
}

.section {
  padding: 0;
}

.profile-tabs /deep/ {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}

.ch-section {
  margin: 15px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ca-reviews-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.ca-review {
  max-width: 350px;
  margin: 48px auto;
  
  .md-card-content {
    padding-top: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.ca-review-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  .ca-review--by {
    max-width: 130px;
    min-width: 130px;
    padding: 0 1rem;
    margin-top: -48px;
  }
  .ca-review--by-image {

  }
  .ca-review--by-right {
    padding-right: 0;
    padding-left: 1rem;
  }
  p {
    margin-top: 10px;
  }
}

.ca-review--signature {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin-top: 0;
  }

  .ca-review--by-name {
    margin-bottom: 0;
    font-size: .8rem;
  }
  small {
    font-size: .8rem;
    font-style: italic;
  }
}

.mapouter {
  position: relative;
  text-align: right;
  height: 500px;
  max-width: 690px;
  width: 100%;
}

.gmap_canvas {
  overflow: hidden;
  background: none !important;
  height: 500px;
  width: 100%;

  iframe {
    height: 100%;
    width: 100%;
  }
}

.directions {
  .description {
    margin-top: 0;
  }
}

.paragraph-spacer {
  margin: 0.8rem;
}

.opening-times {
  display: flex;
  flex-direction: column;
  min-width: 360px;
  margin: 0 0 1rem;

  div {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
}

@media only screen and (max-width: 1201px) {
  .ca-reviews-container {
    flex-direction: column;
  }
  .ca-review {
    max-width: 100%;
    width: 100%;
  }
}
</style>
